import { BoxProps, Box, Grid } from "@mui/material";
import { ReactNode, useMemo } from "react";
import {
  AcCharger,
  IdlingPenalty,
  DcCharger,
  Cash,
  Setting,
  Location,
  Trophy,
  InfoTriangle,
  InfoCricle,
  NotAvailable,
  History,
  Battery,
  Gas,
  Timer,
  Disconnect,
  IconPublicPricing,
  Wifi,
  User,
  Success,
  Flash,
  Transaction,
  LocationIcon,
  ActiveIdlingSession,
  HistoricalIdlingSession,
  UpcomingReservation,
  RestrictedUsers,
  MenuChargeSession,
  ActiveQueuing,
  CompletedQueuing,
  LeaveMissedQueue,
  SubscriptionPlan,
  Subscription,
  PerformanceReport,
  HistorySession,
  Reservation,
  UserSelectChargepoint,
  TargetIcon,
} from "../../assets/icon";

export type IconType =
  | "AcCharger"
  | "Trophy"
  | "Cash"
  | "Setting"
  | "Location"
  | "DcCharger"
  | "IdLingPenalty"
  | "InfoTriangle"
  | "Disconnect"
  | "InfoCricle"
  | "NotAvailable"
  | "Battery"
  | "User"
  | "Gas"
  | "History"
  | "Timer"
  | "Success"
  | "Wifi"
  | "Flash"
  | "Transaction"
  | "ActiveIdlingSession"
  | "HistoricalIdlingSession"
  | "LocationIcon"
  | "RestrictedUsers"
  | "UpcomingReservation"
  | "MenuChargeSession"
  | "ActiveQueuing"
  | "LeaveMissedQueue"
  | "CompletedQueuing"
  | "SubscriptionPlan"
  | "Subscription"
  | "PerformanceReport"
  | "HistorySession"
  | "IconPublicPricing"
  | "Reservation"
  | "TargetIcon"
  | "UserSelectChargepoint";

type IconAppProps = {
  name: IconType;
  color?: string;
} & BoxProps;

const ListIcons: Record<IconType, (props: { color?: string }) => ReactNode> = {
  AcCharger: (props) => <AcCharger {...props} />,
  Trophy: (props) => <Trophy {...props} />,
  Cash: (props) => <Cash {...props} />,
  Setting: (props) => <Setting {...props} />,
  Location: (props) => <Location {...props} />,
  DcCharger: (props) => <DcCharger {...props} />,
  IdLingPenalty: (props) => <IdlingPenalty {...props} />,
  InfoTriangle: (props) => <InfoTriangle {...props} />,
  InfoCricle: (props) => <InfoCricle {...props} />,
  NotAvailable: (props) => <NotAvailable {...props} />,
  History: (props) => <History {...props} />,
  Battery: (props) => <Battery {...props} />,
  Gas: (props) => <Gas {...props} />,
  Timer: (props) => <Timer {...props} />,
  Wifi: (props) => <Wifi {...props} />,
  Disconnect: (props) => <Disconnect {...props} />,
  User: (props) => <User {...props} />,
  Success: (props) => <Success {...props} />,
  Flash: (props) => <Flash {...props} />,
  Transaction: (props) => <Transaction {...props} />,
  LocationIcon: (props) => <LocationIcon {...props} />,
  ActiveIdlingSession: (props) => <ActiveIdlingSession {...props} />,
  HistoricalIdlingSession: (props) => <HistoricalIdlingSession {...props} />,
  UpcomingReservation: (props) => <UpcomingReservation {...props} />,
  RestrictedUsers: (props) => <RestrictedUsers {...props} />,
  MenuChargeSession: (props) => <MenuChargeSession {...props} />,
  ActiveQueuing: (props) => <ActiveQueuing {...props} />,
  CompletedQueuing: (props) => <CompletedQueuing {...props} />,
  LeaveMissedQueue: (props) => <LeaveMissedQueue {...props} />,
  SubscriptionPlan: (props) => <SubscriptionPlan {...props} />,
  Subscription: (props) => <Subscription {...props} />,
  PerformanceReport: (props) => <PerformanceReport {...props} />,
  HistorySession: (props) => <HistorySession {...props} />,
  IconPublicPricing: (props) => <IconPublicPricing {...props} />,
  Reservation: (props) => <Reservation {...props} />,
  TargetIcon: (props) => <TargetIcon {...props} />,
  UserSelectChargepoint: (props) => <UserSelectChargepoint {...props} />
};

//display data

export const IconApp = (props: IconAppProps) => {
  const { name, color, ...restProps } = props;
  const IconComponent = useMemo(() => ListIcons[name], [name]);
  return (
    <Box display={"flex"} height="100%" alignSelf={"center"} {...restProps}>
      {IconComponent && IconComponent({ color: color })}
    </Box>
  );
};

export const AllIcon = () => {
  return (
    <Grid container spacing={2}>
      {Object.keys(ListIcons).map((icon) => {
        return (
          <Grid item xs={6}>
            <Box display={"flex"} alignItems="center" gap={2}>
              <IconApp name={icon as IconType} width={30} />
              <Box>{icon}</Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};
